import React, { useState } from "react";
import store from "../../store";
import { connect, useDispatch } from "react-redux";
import { renderImg } from "../common/icons/img";

import {
    updateSearchResults,
    updateSortBy
} from "../../actions/search-actions";
import { ARRIVAL_TIME, DEPARTURE_TIME, JOURNEY_DURATION, SEAT_FARE, SORT_BY, t } from "../../translations/Search";

const SortDetails = () => {

    const [sorter, setSorter] = useState(0);
    const props = store.getState();

    const calculateTimeDifference = (schedule) => {
        const departureTime = new Date(schedule.DepartureTime);
        const arrivalTime = new Date(schedule.ArrivalTime);
        return arrivalTime.getTime() - departureTime.getTime();
    };

    const sortBus = (val) => {
        let buses = props.search.buses;
        if (val === 1 && sorter !== 1) {
            buses = buses.sort((a, b) => {
                return a.DepartureTime > b.DepartureTime
                    ? 1
                    : b.DepartureTime > a.DepartureTime
                        ? -1
                        : 0;
            });
        } else if (val === 2 && sorter !== 2) {
            buses = buses.sort((a, b) => {
                return a.DepartureTime < b.DepartureTime
                    ? 1
                    : b.DepartureTime < a.DepartureTime
                        ? -1
                        : 0;
            });
        } else if (val === 3 && sorter !== 3) {
            buses = buses.sort((a, b) => {
                const differenceA = calculateTimeDifference(a);
                const differenceB = calculateTimeDifference(b);
                return differenceA - differenceB;
            });
        } else if (val === 4 && sorter !== 4) {
            buses = buses.sort((a, b) => {
                const differenceA = calculateTimeDifference(a);
                const differenceB = calculateTimeDifference(b);
                return differenceB - differenceA;
            });
        } else if (val === 5 && sorter !== 5) {
            buses = buses.sort((a, b) => {
                return a.ArrivalTime < b.ArrivalTime ? 1 : b.ArrivalTime < a.ArrivalTime ? -1 : 0;
            });
        } else if (val === 6 && sorter !== 6) {
            buses = buses.sort((a, b) => {
                return a.ArrivalTime > b.ArrivalTime ? 1 : b.ArrivalTime > a.ArrivalTime ? -1 : 0;
            });
        } else if (val === 7 && sorter !== 7) {
            buses = buses.sort((a, b) => {
                return a.DiscFare < b.DiscFare ? 1 : b.DiscFare < a.DiscFare ? -1 : 0;
            });
        } else if (val === 8 && sorter !== 8) {
            buses = buses.sort((a, b) => {
                return a.DiscFare > b.DiscFare ? 1 : b.DiscFare > a.DiscFare ? -1 : 0;
            });
        }
        setSorter(val)
        store.dispatch(updateSortBy(val));
        store.dispatch(updateSearchResults(buses));
    };

    return (
        <div className="search--sort--container">
            <div className="sort--item">
                <div className="icon">{renderImg('sortBy')}</div>
                <div>{t(SORT_BY)}</div>
            </div>
            <div className="sort--item">
                <div>{t(DEPARTURE_TIME)}</div>
                <div className="icon">
                    <div onClick={() => sortBus(1)}>{renderImg('sort-arrow-down')}</div>
                    <div onClick={() => sortBus(2)}>{renderImg('sort-arrow-up')}</div>
                </div>
            </div>
            <div className="sort--item">
                <div>{t(JOURNEY_DURATION)}</div>
                <div className="icon">
                    <div onClick={() => sortBus(3)}>{renderImg('sort-arrow-down')}</div>
                    <div onClick={() => sortBus(4)}>{renderImg('sort-arrow-up')}</div>
                </div>
            </div>
            <div className="sort--item">
                <div>{t(ARRIVAL_TIME)}</div>
                <div className="icon">
                    <div onClick={() => sortBus(5)}>{renderImg('sort-arrow-down')}</div>
                    <div onClick={() => sortBus(6)}>{renderImg('sort-arrow-up')}</div>
                </div>
            </div>
            <div className="sort--item">
                <div>{t(SEAT_FARE)}</div>
                <div className="icon">
                    <div onClick={() => sortBus(7)}>{renderImg('sort-arrow-down')}</div>
                    <div onClick={() => sortBus(8)}>{renderImg('sort-arrow-up')}</div>
                </div>
            </div>

        </div>
    )
}


const mapStateToProps = function (store) {
    return store;
};

export default connect(mapStateToProps)(SortDetails);
